import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { CompaniesProvider } from '../../providers/companies/companies.provider';
import { Sucursal } from '../../services/lbsdk/models/Sucursal';
import { CompanyPage } from './company/company';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AuthService } from '../../services/auth/auth.service';
import { UsuarioSucursalApi } from '../../services/lbsdk';




@IonicPage()
@Component({
  selector: 'page-companies',
  templateUrl: 'companies.html',
})
export class CompaniesPage {
  empresaSel
  companies: Sucursal[] = [];
  paginationInfo = {
    page: 0,
    pageSize: 0,
    rowCount: 0,
    pageCount: 0
  }
  sortReverse: boolean = false;
  sortField: string = 'nombre';
  sortType: string = 'ASC';
  searchKey: string = '';
  sucursales;
  sucursal: Sucursal[] = [];
  empresa;
  admin;
  sucursalesUsuarioOriginal = [];
  superAdmin;

  private subject: Subject<string> = new Subject<string>();

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private companiesProvider: CompaniesProvider,
    private loading: LoadingController,
    private authService: AuthService,
    private usuarioSucursalApi: UsuarioSucursalApi,

  ) {
  }

  cambioEmpresa(event) {
    this.ionViewDidEnter()
  }
  ionViewDidLoad() {
    this.superAdmin = this.authService.isSuperAdministrador();
    this.admin = this.authService.isAdministrador();

  }
  ionViewDidEnter() {
    console.log("***** ADMINISTRADOR: ", this.authService.isAdministrador())

    let loader = this.loading.create({
      content: 'Aguarde se están obteniendo los datos...'
    });

    if (!this.empresaSel){
      if (this.authService.empresasUsuario.length > 0){
        this.empresaSel = this.authService.empresasUsuario[0]
      }
    }


    loader.present();

    this.subject.pipe(
      debounceTime(200))
      .subscribe(searchTextValue => {
        this.searchKey = searchTextValue;
        this.handleSearch(searchTextValue);
      });

    // SI ES ADMINISTRADOR TRAIGO TODAS
    if (this.authService.isSuperAdministrador()) {
      let countObs
     // alert("EMPRESA SELECCIONADA " + this.empresaSel)
      if (this.empresaSel) {
        countObs = this.companiesProvider.count({ idempresa: this.empresaSel.idEmpresa })
      }
      else {
        countObs = this.companiesProvider.count("")
      }


      //this.companiesProvider.count("")
      countObs
        .subscribe(res => {


          console.log('cant sucursales' + res.count);

          this.paginationInfo.rowCount = res.count
          this.paginationInfo.pageSize = 5;;
          this.paginationInfo.pageCount = Math.ceil((this.paginationInfo.rowCount / this.paginationInfo.pageSize));
          this.paginationInfo.page = 1;
          let consulta
          if (this.empresaSel) {
            consulta = this.companiesProvider.find({ where: { idempresa: this.empresaSel.idEmpresa }, limit: 5, order: `${this.sortField} ${this.sortType}` })
          }
          else {
            consulta = this.companiesProvider.find({ limit: 5, order: `${this.sortField} ${this.sortType}` })
          }


          // this.companiesProvider.find({ limit: 5, order: `${this.sortField} ${this.sortType}` })
          consulta
            .subscribe((sucursal: Sucursal[]) => {


              this.sucursal = sucursal;


              loader.dismiss();

            }, error => loader.dismiss)


        }, error => loader.dismiss)

    }
    else {

      let aux = JSON.parse(sessionStorage.getItem('userData'));
      console.log("DATA A FILTRAR", aux.sucursales);

      let idSucursales = aux.sucursales.map(x => x.idsucursal)

      this.companiesProvider.find({ where: { idsucursal: { inq: idSucursales } }, limit: 5 })
        .subscribe((respuesta: Sucursal[]) => {
          //           alert(JSON.stringify(respuesta))
          this.paginationInfo.rowCount = aux.sucursales.length
          this.paginationInfo.pageSize = 5;;
          this.paginationInfo.pageCount = Math.ceil((this.paginationInfo.rowCount / this.paginationInfo.pageSize));
          this.paginationInfo.page = 1;
          this.sucursal = respuesta;
        })
      //console.log("ARRAY SUCURSALES ", idSucursales)



      loader.dismiss();
    }

  }


  onKeyUp(event) {

    if (event.target.value.toString().length > 3) {
      const searchKey = event.target.value;
      this.subject.next(searchKey);
    }

    if (event.target.value.toString().length == 0) {
      const searchKey = event.target.value;
      this.subject.next(searchKey);
    }

  }

  addNew() {
    let newCompany: Sucursal = new Sucursal();
    this.navCtrl.push(CompanyPage, { data: newCompany })
  }

  update(company: Sucursal) {
    this.navCtrl.push(CompanyPage, { data: company });
  }


  setOrder(field: string) {
    this.sortField = field;
    this.sortReverse = !this.sortReverse;
    this.sortType = this.sortReverse ? ' DESC' : ' ASC';
    this.handleSearch(this.searchKey);
  }

  //#region Paginador

  changePage(valor) {
    // console.log(valor)
    let loader = this.loading.create({
      content: 'Aguarde se están obteniendo los datos...'
    });
    loader.present();
    if (this.authService.isSuperAdministrador()) {
      this.paginationInfo.page = valor;
      let pageAux = this.paginationInfo.page == 1 ? 0 : this.paginationInfo.page
      let skipElements = pageAux * this.paginationInfo.pageSize - 5;

      if (skipElements < 0) skipElements = 0;

      let filtro = {}
      filtro = {
        where: {
          or: [
            { nombre: { like: '%' + this.searchKey + '%' } },
            { email: { like: '%' + this.searchKey + '%' } }
          ]
        },
        skip: (skipElements), limit: 5, order: `${this.sortField} ${this.sortType}`
      }
      console.log(filtro);


      this.companiesProvider.find(filtro)
        .subscribe((sucursal: Sucursal[]) => {

          this.sucursal = sucursal;

          loader.dismiss();
        }, error => loader.dismiss())
    }
    else {
      console.log("CAMBIO PAGE");
      let aux = JSON.parse(sessionStorage.getItem('userData'));
      let idSucursales = aux.sucursales.map(x => x.idsucursal)
      this.paginationInfo.page = valor;
      let pageAux = this.paginationInfo.page == 1 ? 0 : this.paginationInfo.page
      let skipElements = (pageAux * this.paginationInfo.pageSize) - 5;

      if (skipElements < 0) skipElements = 0;
      this.companiesProvider.find({
        where: {
          and: [{
            idsucursal: { inq: idSucursales }
          }, { nombre: { like: '%' + this.searchKey + '%' } }]
        }, limit: 5, skip: skipElements
      })
        .subscribe((respuesta: Sucursal[]) => {
          //           alert(JSON.stringify(respuesta))

          this.sucursal = respuesta;

          loader.dismiss();

        })


    }
  }
  //#endregion

  public handleSearch(searchKey: string) {


    if (this.authService.isSuperAdministrador()) {
      console.log(`handleSearch:  ${searchKey}`, this.paginationInfo)
      let observable
      //NEW}

      observable = this.companiesProvider.count({})


      observable.subscribe(res => {
        console.log(res);
        this.paginationInfo.rowCount = res.count;
        this.paginationInfo.pageSize = 5,
          this.paginationInfo.pageCount = (this.paginationInfo.rowCount / this.paginationInfo.pageSize)
        this.paginationInfo.page = 1
        let pageAux = this.paginationInfo.page == 1 ? 0 : this.paginationInfo.page
        let filtro = {}
        filtro = {
          where: {
            or: [
              { nombre: { like: '%' + this.searchKey + '%' } },
              { email: { like: '%' + this.searchKey + '%' } },
              // { activationCode: { regexp: '/' + this.searchKey + '/i' } },
              // { active: { regexp: '/' + this.searchKey + '/i' } }
            ]
          },
          skip: (pageAux * this.paginationInfo.pageSize), limit: 5, order: `${this.sortField} ${this.sortType}`
        }

        this.companiesProvider.find(filtro)
          .subscribe((sucursal: Sucursal[]) => {

            this.sucursal = sucursal;

            if (this.searchKey.length > 3) {
              this.paginationInfo.rowCount = sucursal.length
              this.paginationInfo.pageCount = Math.ceil((this.paginationInfo.rowCount / this.paginationInfo.pageSize))

            }

            // loader.dismiss();
          })


      }, error => console.log("error"))/*loader.dismiss()*/
    }
    else {


      console.log("CAMBIO PAGE");

      console.log("CAMBIO PAGE");
      let aux = JSON.parse(sessionStorage.getItem('userData'));
      let idSucursales = aux.sucursales.map(x => x.idsucursal)
      this.paginationInfo.page = 1;
      let pageAux = this.paginationInfo.page == 1 ? 0 : this.paginationInfo.page
      this.paginationInfo.rowCount = idSucursales.length
      this.paginationInfo.pageCount = Math.ceil((this.paginationInfo.rowCount / this.paginationInfo.pageSize))
      this.companiesProvider.find({
        where: {
          and: [{
            idsucursal: { inq: idSucursales }
          }, { nombre: { like: '%' + this.searchKey + '%' } }]
        }, limit: 5, skip: (pageAux * this.paginationInfo.pageSize)
      })
        .subscribe((respuesta: Sucursal[]) => {
          //           alert(JSON.stringify(respuesta))


          if (this.searchKey.length > 3) {
            this.paginationInfo.rowCount = respuesta.length
            this.paginationInfo.pageCount = Math.ceil((this.paginationInfo.rowCount / this.paginationInfo.pageSize))
          }
          this.sucursal = respuesta;



        })

    }


  }




}

export class paginationInfo {
  page: number;
  pageSize: number;
  rowCount: number;
  pageCount: number;
}


// WEBPACK FOOTER //
// ./src/pages/companies/companies.ts